<template>
    <div>
        <section class="content">
            <div class="container-fluid">

                <div class="row clearfix">

                    <div class="bg-light-green" style="margin-top:-1% !important;">
                        <!-- <br> -->
                        <div class="row paddingku">
                            <div class="col-md-3 searching">
                                <span class="h_page">Kegiatan SKPD</span> <br> <br>
                            </div>
                            <div class="col-md-6">

                            </div>
                            <div class="col-md-3 searching">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button @click="btn_check_data_add()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                                    </span>
                                    <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                                </div> <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 card">
                <!-- ============================================================ MULAI ======================================================================== -->
                        <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">
                            <div class="col-md-4">
                                <span class="huruf_input">Unit Kerja</span>
                                <autocomplete
                                    :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    anchor="unit_kerja"
                                    :initValue="''"
                                    :placeholder="unit_kerja_full"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild"
                                    :on-select="getAuto">
                                </autocomplete>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Periode Renstra</span>
                                <select class="form-control show-tick" v-model="form.id_renstra">
                                    <option value="" >-- Semua Periode --</option>
                                    <option v-for="data in list_Renstra" :key="data.id_renstra" :value="data.id_renstra">{{data.periode}}</option>
                                </select>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Bidang Urusan</span>
                                <select  @change="getProgramPembangunan()"  class="form-control show-tick" v-model="form.bidang_urusan_pemerintahan_id">
                                    <option value="" >-- Pilih Bidang Urusan --</option>
                                    <option v-for="data in list_Bidang" :key="data.bidang_urusan_pemerintahan_id" :value="data.bidang_urusan_pemerintahan_id">{{data.nama_bidang}}</option>
                                </select>
                            </div>

                        </div>
                        <div class="row" style="padding-top:0.5%">
                            <div class="col-md-12">
                                <span class="huruf_input">Program Pembangunan</span>
                                <select @change="cari_data()" class="form-control show-tick" v-model="form.renstra_program_pembangunan">
                                    <option value="" >-- Pilih Program --</option>
                                    <option v-for="data in list_Program" :key="data.renstra_program_pembangunan_id" :value="data">[{{data.program_kode}}] {{data.program_nama}} / {{data.renstra_program_pembangunan_id}}</option>
                                </select>
                            </div>
                        </div>
                        <hr>
                        
                        <div class="table-responsive">
                            <table class="table table-bordered" style="width: 100%">
                                <thead>
                                    <tr class="bg-light-green kepala_table_f tabel_center">
                                        <th class="text-center tabel_center" rowspan="2" style="width: 7%">Kode</th>
                                        <th class="text-center tabel_center" rowspan="2" style="width: 30%">Nama Kegiatan</th>
                                        <th class="text-center" colspan="6">Anggaran</th>
                                        <th class="text-center tabel_center" rowspan="2" style="width: 15%">Kode</th>
                                    </tr>
                                    <tr class="bg-light-green kepala_table_f tabel_center">
                                        <th class="text-center" style="width: 8%">Tahun 1</th>
                                        <th class="text-center" style="width: 8%">Tahun 2</th>
                                        <th class="text-center" style="width: 8%">Tahun 3</th>
                                        <th class="text-center" style="width: 8%">Tahun 4</th>
                                        <th class="text-center" style="width: 8%">Tahun 5</th>
                                        <th class="text-center" style="width: 8%">Tahun 6</th>
                                    </tr>
                                </thead>
                                <tbody class="tabel_center" >
                                    <tr class="h_isitable4" v-for="data in list_data" :key="data.renstra_kegiatan_id">
                                        <td class="tabel_center text-center">{{data.kode}}</td>
                                        <td class="tabel_center">{{data.kegiatan_nama}}</td>
                                        <td class="tabel_center">{{format_uang(data.tahun_1)}}</td>
                                        <td class="tabel_center">{{format_uang(data.tahun_2)}}</td>
                                        <td class="tabel_center">{{format_uang(data.tahun_3)}}</td>
                                        <td class="tabel_center">{{format_uang(data.tahun_4)}}</td>
                                        <td class="tabel_center">{{format_uang(data.tahun_5)}}</td>
                                        <td class="tabel_center">{{format_uang(data.tahun_6)}}</td>

                                        <td class="tabel_center text-center" >
                                            <button @click="selectData(data)" class="btn bg-light-blue btn-xs waves-effect " title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_list_data_indikator">
                                                <i style="font-size:100%;" class="material-icons" >control_point</i>
                                            </button>
                                            &nbsp;
                                            <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Pengaturan Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                                <i style="font-size:100%" class="material-icons" >settings</i>
                                            </button>
                                            &nbsp;
                                            <button @click="removeData(data.renstra_kegiatan_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                                <i style="font-size:100%" class="material-icons" >clear</i>
                                            </button>

                                        </td>
                                    </tr>
                                    <tr class="h_isitable4 bg-success">
                                        <td class="tabel_center text-center" colspan="2">TOTAL PAGU INDIKATIF KEGIATAN SKPD</td>

                                        <td class="tabel_center">{{format_uang(tahun.tahun_1)}}</td>
                                        <td class="tabel_center">{{format_uang(tahun.tahun_2)}}</td>
                                        <td class="tabel_center">{{format_uang(tahun.tahun_3)}}</td>
                                        <td class="tabel_center">{{format_uang(tahun.tahun_4)}}</td>
                                        <td class="tabel_center">{{format_uang(tahun.tahun_5)}}</td>
                                        <td class="tabel_center">{{format_uang(tahun.tahun_6)}}</td>

                                        <td class="tabel_center text-center" ></td>
                                    </tr>
                                    <tr class="h_isitable4 bg-light-green">
                                        <td class="tabel_center text-center" colspan="2">TOTAL PAGU RPJMD</td>

                                        <td class="tabel_center">{{format_uang(ttl_rpjmd.tahun_1)}}</td>
                                        <td class="tabel_center">{{format_uang(ttl_rpjmd.tahun_2)}}</td>
                                        <td class="tabel_center">{{format_uang(ttl_rpjmd.tahun_3)}}</td>
                                        <td class="tabel_center">{{format_uang(ttl_rpjmd.tahun_4)}}</td>
                                        <td class="tabel_center">{{format_uang(ttl_rpjmd.tahun_5)}}</td>
                                        <td class="tabel_center">{{format_uang(ttl_rpjmd.tahun_6)}}</td>

                                        <td class="tabel_center text-center" ></td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>

                        <hr>
                            <!-- <div class="text-center">
                                <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                                    <i class="material-icons">skip_previous</i>
                                </button>
                                &nbsp;
                                <span style="font-size: 85%; color: #a5a5a5">
                                    <b>{{page_first}} - {{page_last}}</b>
                                </span>
                                &nbsp;
                                <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                                    <i class="material-icons">skip_next</i>
                                </button>
                            </div>
                        <hr> -->


                        <!-- ============================================================ MODAL ======================================================================== -->


                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                        </div>

                                        <form @submit.prevent="addData()">

                                            <div class="modal-body">
                                                <div v-if="!check_data_add" class="alert alert-info text-center">
                                                    <strong>SILAHKAN PILIH PERIODE RENSTRA DAN BIDANG URUSAN TERLEBIH DAHULU!</strong> 
                                                </div>

                                                <div v-if="check_data_add">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered" style="width: 100%">
                                                            <thead>
                                                            <tr class="bg-info kepala_table_f tabel_center">

                                                                <th class="tabel_center text-center" style="width: 10%">Pilih</th>
                                                                <th class="tabel_center text-center" style="width: 10%">Kode</th>
                                                                <th class="tabel_center text-center" style="width: 80%">Nama Kegiatan</th>
                                                                <!-- <th class="tabel_center text-center" style="width: 40%">Prioritas</th> -->
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr class="h_isitable" v-for="data in list_Kegiatan" :key="data.kegiatan_id">
                                                                <td class="tabel_center text-center" >
                                                                    <input v-model="form.kegiatan" type="checkbox" :value="data.kegiatan_id" :id="data.kegiatan_id" class="filled-in chk-col-blue" :checked="1">
                                                                    <label :for="data.kegiatan_id"></label>
                                                                </td>
                                                                <td class="tabel_center" >{{data.kode}}</td>
                                                                <td class="tabel_center text-justify">{{data.kegiatan_nama}}</td>
                                                            </tr>

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                                <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-green">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                        </div>
                                        <form @submit.prevent="editData()">
                                            <div class="modal-body">
                                               
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Anggaran Thn 1</label>
                                                    </div>
                                                    <div class="col-md-2">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="form.tahun_1" type="number" class="form-control" placeholder="Ex : ">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Anggaran Thn 2</label>
                                                    </div>
                                                    <div class="col-md-2">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="form.tahun_2" type="number" class="form-control" placeholder="Ex : ">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Anggaran Thn 3</label>
                                                    </div>
                                                    <div class="col-md-2">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="form.tahun_3" type="number" class="form-control" placeholder="Ex : ">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Anggaran Thn 4</label>
                                                    </div>
                                                    <div class="col-md-2">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="form.tahun_4" type="number" class="form-control" placeholder="Ex : ">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Anggaran Thn 5</label>
                                                    </div>
                                                    <div class="col-md-2">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="form.tahun_5" type="number" class="form-control" placeholder="Ex : ">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Anggaran Thn 6</label>
                                                    </div>
                                                    <div class="col-md-2">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="form.tahun_6" type="number" class="form-control" placeholder="Ex : ">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Keterangan</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="form.keterangan" type="text" class="form-control" placeholder="Ex : ">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                                <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST INDIKATOR xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_list_data_indikator" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-xlg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TLIST INDIKATOR</h4>
                                        </div>

                                            <div class="modal-body">

                                                <button class="btn btn-info" data-toggle="modal" data-target="#m_tambah_data_indikator_kinerja">Tambah Indikator</button>
                                                <hr>
                                                <div class="table-responsive">
                                                    <table class="table-bordered" style="width: 100%">
                                                        <thead>
                                                        <tr class="bg-info kepala_table_f tabel_center">

                                                            <th class="tabel_center text-center" rowspan="2" style="width:5%">No</th>
                                                            <th class="tabel_center text-center" rowspan="2" style="width:30%">Uraian Indikator</th>
                                                            <th class="tabel_center text-center" rowspan="2" style="width:5%">Satuan</th>
                                                            <th class="tabel_center text-center" rowspan="2" style="width:10%">Rumusan Satuan</th>

                                                            <th class="tabel_center text-center" colspan="8">Target</th>

                                                            <th class="tabel_center text-center" rowspan="2" style="width:10%">#</th>
                                                        </tr>
                                                        <tr class="bg-info kepala_table_f tabel_center">
                                                            <th class="tabel_center text-center" style="width:5%">Capaian Awal</th>
                                                            <th class="tabel_center text-center" style="width:5%">Tahun Ke 1</th>
                                                            <th class="tabel_center text-center" style="width:5%">Tahun Ke 2</th>
                                                            <th class="tabel_center text-center" style="width:5%">Tahun Ke 3</th>
                                                            <th class="tabel_center text-center" style="width:5%">Tahun Ke 4</th>
                                                            <th class="tabel_center text-center" style="width:5%">Tahun Ke 5</th>
                                                            <th class="tabel_center text-center" style="width:5%">Tahun Ke 6</th>
                                                            <th class="tabel_center text-center" style="width:5%">Kondisi Akhir</th>
                                                        </tr>
                                                    </thead>
                                                        <tbody>
                                                        <tr class="h_isitablex" v-for="data in list_Indikator" :key="data.renstra_kegiatan_indikator_id">
                                                            <td class="tabel_center text-center">{{data.no_indikator}}</td>
                                                            <td class="tabel_center" >{{data.uraian}}</td>
                                                            <td class="tabel_center text-center">{{data.satuan}}</td>
                                                            <td class="tabel_center text-center">{{data.rumus_satuan}}</td>
                                                            <td class="tabel_center text-center">{{format_uang(data.capaian_awal)}}</td>
                                                            <td class="tabel_center text-center">{{format_uang(data.thn_1)}}</td>
                                                            <td class="tabel_center text-center">{{format_uang(data.thn_2)}}</td>
                                                            <td class="tabel_center text-center">{{format_uang(data.thn_3)}}</td>
                                                            <td class="tabel_center text-center">{{format_uang(data.thn_4)}}</td>
                                                            <td class="tabel_center text-center">{{format_uang(data.thn_5)}}</td>
                                                            <td class="tabel_center text-center">{{format_uang(data.thn_6)}}</td>
                                                            <td class="tabel_center text-center">{{format_uang(data.kondisi_akhir)}}</td>

                                                            <td class="tabel_center text-center" >
                                                                <button @click="selectDataIndikator(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" data-toggle="modal" data-target="#m_edit_data_indikator_kinerja">
                                                                    <i style="font-size:100%" class="material-icons" >create</i>
                                                                </button>
                                                                &nbsp;
                                                                <button @click="removeDataIndikator(data.renstra_kegiatan_indikator_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data">
                                                                    <i style="font-size:100%" class="material-icons" >clear</i>
                                                                </button>


                                                            </td>
                                                        </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                   
                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                                <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST INDIKATOR xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH INDIKATOR KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_tambah_data_indikator_kinerja" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">INDIKATOR SASARAN KEGIATAN</h4>
                                        </div>
                                    <form @submit.prevent="addindikator()">
                                        <div class="modal-body">

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">No Indikator</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.no_indikator" type="text" class="form-control" placeholder="Ex : 1">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Uraian Indikator</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.uraian" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Satuan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.satuan" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Rumusan Satuan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.rumus_satuan" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Capaian Awal</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.capaian_awal" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 1</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_1" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 2</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_2" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 3</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_3" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 4</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_4" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 5</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_5" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 6</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_6" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Kondisi Akhir</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.kondisi_akhir" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        </div>
                                        <div class="modal-footer">
                                            <button type="submit" class="btn bg-light-blue waves-effect" >SIMPAN</button>
                                            <button  type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                        </div>
                                    </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH INDIKATOR KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT INDIKATOR KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_edit_data_indikator_kinerja" tabindex="-1" role="dialog" data-backdrop="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-green">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">UBAH INDIKATOR SASARAN KEGIATAN</h4>
                                        </div>
                                    <form @submit.prevent="editindikator()">
                                        <div class="modal-body">

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">No Indikator</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.no_indikator" type="text" class="form-control" placeholder="Ex : 1">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Uraian Indikator</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.uraian" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Satuan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.satuan" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Rumusan Satuan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.rumus_satuan" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Capaian Awal</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.capaian_awal" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 1</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_1" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 2</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_2" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 3</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_3" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 4</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_4" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 5</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_5" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 6</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_6" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Kondisi Akhir</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.kondisi_akhir" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        </div>
                                        <div class="modal-footer">
                                            <button type="submit" class="btn bg-light-green waves-effect" >SIMPAN</button>
                                            <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                        </div>
                                    </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT INDIKATOR KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                       
                        <!-- ============================================================ MODAL ======================================================================== -->
                <!-- ============================================================ MULAI ======================================================================== -->
                    </div>

                </div>

            </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/planning_renstra_kegiatan/';
    const ADD_URL_RENSTRA = URL_APP+'api/v1/planning_renstra_renstra/';
    const ADD_URL_UNIT_KERJA = URL_APP+'api/v1/simpeg_unit_kerja/';
    const URL_SERVER = URL_APP;

    const ADD_BIDANG_URUSAN = URL_APP+'api/v1/planning_program_pembangunan/';
    const ADD_RENSTRA_PROGRAM = URL_APP+'api/v1/planning_renstra_program/';
    const ADD_KEGIATAN = URL_APP+'api/v1/planning_kegiatan/';

    import Autocomplete from 'vue2-autocomplete-js'

    export default {
        name: "planning_rpjmd",
        components: { Autocomplete },
        data() {
            return {

                form : {
                    renstra_kegiatan_id : '',
                    id_renstra : '',
                    bidang_urusan_pemerintahan_id : '',

                    program_id : '',
                    program_pembangunan_id : '',
                    renstra_program_pembangunan_id : '',

                    kegiatan_id : '',

                    instansi_id : '',
                    unit_kerja : '',

                    tahun_1 : 0,
                    tahun_2 : 0,
                    tahun_3 : 0,
                    tahun_4 : 0,
                    tahun_5 : 0,
                    tahun_6 : 0,
                    keterangan : '',

                    renstra_program_pembangunan : {},
                    kegiatan : [],
                },

                unit_kerja : '',
                unit_kerja_full : '',
                unit_kerja_edit : '',
                instansi_id : '',

                check_data_add : false,

                list_data : [],
                list_Renstra: [],
                list_Bidang: [],
                list_Program: [],
                list_Kegiatan: [],
                list_Indikator: [],
                
                page_first : 1,
                page_last : 0,
                cari_value : '',

                token : localStorage.token,
                URL : URL_SERVER,

                indikator : {
                    renstra_kegiatan_indikator_id : '',
                    renstra_kegiatan_id : '',
                    no_indikator : 0,
                    uraian : '',
                    satuan : '',
                    rumus_satuan : '',
                    capaian_awal : 0,
                    thn_1 : 0,
                    thn_2 : 0,
                    thn_3 : 0,
                    thn_4 : 0,
                    thn_5 : 0,
                    thn_6 : 0,
                    kondisi_akhir : 0,

                },

                tahun : {
                    tahun_1 : 0,
                    tahun_2 : 0,
                    tahun_3 : 0,
                    tahun_4 : 0,
                    tahun_5 : 0,
                    tahun_6 : 0,
                },

                ttl_rpjmd : {
                    tahun_1 : 0,
                    tahun_2 : 0,
                    tahun_3 : 0,
                    tahun_4 : 0,
                    tahun_5 : 0,
                    tahun_6 : 0,
                }
            };
        },

        mounted() {
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;
            this.instansi_id = get_profile.profile.instansi_id;

            this.form.unit_kerja = get_profile.profile.unit_kerja;
            this.form.instansi_id = get_profile.profile.instansi_id;

            this.getRenstra();

            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },

                    body: JSON.stringify(this.form)
                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });

                // console.log(this.form);
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        data_ke : this.page_first,
                        cari_value : this.cari_value,
                        unit_kerja : this.form.unit_kerja,
                        renstra_program_pembangunan_id : this.form.renstra_program_pembangunan.renstra_program_pembangunan_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.list_data = res_data;
                    this.hitung_anggaran();
                    this.hitung_anggaran_RPJMD();
                //   console.log(res_data);
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.form)
                }).then((res_data) => {
                //   console.log(res_data);
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
                this.form.renstra_kegiatan_id = data.renstra_kegiatan_id;
                this.form.tahun_1 = data.tahun_1;
                this.form.tahun_2 = data.tahun_2;
                this.form.tahun_3 = data.tahun_3;
                this.form.tahun_4 = data.tahun_4;
                this.form.tahun_5 = data.tahun_5;
                this.form.tahun_6 = data.tahun_6;
                this.form.keterangan = data.keterangan;

                this.indikator.renstra_kegiatan_id = data.renstra_kegiatan_id;
                this.getDataIndikator();
            },
            selectDataIndikator : function(data){
                this.indikator = {
                    renstra_kegiatan_indikator_id : data.renstra_kegiatan_indikator_id,
                    renstra_kegiatan_id : data.renstra_kegiatan_id,
                    no_indikator : data.no_indikator,
                    uraian : data.uraian,
                    satuan : data.satuan,
                    rumus_satuan : data.rumus_satuan,
                    capaian_awal : data.capaian_awal,
                    thn_1 : data.thn_1,
                    thn_2 : data.thn_2,
                    thn_3 : data.thn_3,
                    thn_4 : data.thn_4,
                    thn_5 : data.thn_5,
                    thn_6 : data.thn_6,
                    kondisi_akhir : data.kondisi_akhir,
                };
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.kebikan_umum_id = '';
                this.no_kebikan_umum = '';
                this.uraian = '';
                this.list_Kegiatan = [];
                this.form.kegiatan = [];
                this.list_Indikator = [];


                this.form.tahun_1 = 0;
                this.form.tahun_2 = 0;
                this.form.tahun_3 = 0;
                this.form.tahun_4 = 0;
                this.form.tahun_5 = 0;
                this.form.tahun_6 = 0;




            },

        //TAMBAHAN



            getRenstra : function(){
                this.page_first = 1;
                fetch(ADD_URL_RENSTRA, {
                    method : 'POST',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    },
                    body : JSON.stringify({
                        unit_kerja : this.unit_kerja
                    })
                }).then(res => res.json()).then((res_data)=>{
                    if (res_data.length <= 0) {
                        this.list_Renstra = [];
                        this.form.id_renstra = '';
                    } else {
                        this.list_Renstra = res_data;
                        this.form.id_renstra = res_data[0].id_renstra;
                    }
                    this.getBidangurusan();
                    // console.log(res_data);
                })
            },

            getBidangurusan : function(){
                this.page_first = 1;
                fetch(ADD_BIDANG_URUSAN+'getBidangUrusanFromRenja', {
                    method : 'POST',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    },
                    body : JSON.stringify({
                        instansi_id : this.form.instansi_id
                    })
                }).then(res => res.json()).then((res_data)=>{
                    this.list_Bidang = res_data;
                    // console.log(res_data);
                    this.form.bidang_urusan_pemerintahan_id = res_data[0].bidang_urusan_pemerintahan_id
                    // this.getData();
                    // console.log(res_data);
                    this.getProgramPembangunan();
                })
            },
            getProgramPembangunan : function(){
                this.page_first = 1;
                fetch(ADD_RENSTRA_PROGRAM+'get_from_renstra', {
                    method : 'POST',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    },
                    body : JSON.stringify({
                        unit_kerja : this.unit_kerja,
                        bidang_urusan_pemerintahan_id : this.form.bidang_urusan_pemerintahan_id
                    })
                }).then(res => res.json()).then((res_data)=>{
                    // console.log(res_data);
                    if (res_data.length <= 0) {
                        this.list_Program = [];
                        this.form.renstra_program_pembangunan = {};
                    }else{
                        this.form.renstra_program_pembangunan = res_data[0]
                        this.list_Program = res_data;
                        this.getData();
                        this.getKegiatan();
                    }
                    // console.log(this.form.renstra_program_pembangunan);
                })
            },

            getKegiatan : function(){
                this.page_first = 1;
                fetch(ADD_KEGIATAN+'get_from_renstra', {
                    method : 'POST',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    },
                    body : JSON.stringify({
                        bidang_urusan_pemerintahan_id : this.form.bidang_urusan_pemerintahan_id,
                        program_id : this.form.renstra_program_pembangunan.program_id
                    })
                }).then(res => res.json()).then((res_data)=>{
                    console.log(res_data);
                    
                    this.list_data.forEach(list_data => {
                        for (let i = 0; i < res_data.length; i++) {
                            if (list_data.kegiatan_id == res_data[i].kegiatan_id) {
                                res_data.splice(i, 1); 
                            }
                        }
                    });

                    this.list_Kegiatan = res_data;

                })
            },
            
            addindikator: function(){
                fetch(ADD_URL+'createDataIndikator', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },

                    body: JSON.stringify(this.indikator)
                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getDataIndikator();
                });

                // console.log(this.form);
            },
            getDataIndikator: function(){
                fetch(ADD_URL+'readDataIndikator', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        renstra_kegiatan_id : this.form.renstra_kegiatan_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_Indikator = res_data;
                //   console.log(res_data);
                })
            },
            editindikator: function(){
                fetch(ADD_URL+'updateDataIndikator', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },

                    body: JSON.stringify(this.indikator)
                }).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getDataIndikator();
                });

                // console.log(this.form);
            },
            removeDataIndikator : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteDataIndikator", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getDataIndikator();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },


            hitung_anggaran : function(){
                var tahun_1 = 0
                var tahun_2 = 0
                var tahun_3 = 0
                var tahun_4 = 0
                var tahun_5 = 0
                var tahun_6 = 0

                var list = this.list_data

                for (let i = 0; i < list.length; i++) {
                    tahun_1 = tahun_1 + list[i].tahun_1;
                    tahun_2 = tahun_2 + list[i].tahun_2;
                    tahun_3 = tahun_3 + list[i].tahun_3;
                    tahun_4 = tahun_4 + list[i].tahun_4;
                    tahun_5 = tahun_5 + list[i].tahun_5;
                    tahun_6 = tahun_6 + list[i].tahun_6;
                    
                }
                this.tahun = {
                    tahun_1 : tahun_1,
                    tahun_2 : tahun_2,
                    tahun_3 : tahun_3,
                    tahun_4 : tahun_4,
                    tahun_5 : tahun_5,
                    tahun_6 : tahun_6,
                };


            },
            hitung_anggaran_RPJMD: function(){
                fetch(ADD_URL+'getTotalPaguRPJMD', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        relasi_program_pembangunan_skpd_id : this.form.renstra_program_pembangunan.relasi_program_pembangunan_skpd_id,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.ttl_rpjmd = {
                        tahun_1 : res_data.tahun_1,
                        tahun_2 : res_data.tahun_2,
                        tahun_3 : res_data.tahun_3,
                        tahun_4 : res_data.tahun_4,
                        tahun_5 : res_data.tahun_5,
                        tahun_6 : res_data.tahun_6,
                    };    

                })
            },
        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                console.log(obj);
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.instansi_id = obj.instansi_id;
                
                this.form.unit_kerja = obj.id;
                this.form.instansi_id = obj.instansi_id;



                this.getRenstra();
                // console.log(obj);
            },
        // ================== AUTOCOMPLETE ====================
        
        // ================== PAGINASI ====================
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            },
            btn_check_data_add : function(){
                if (this.form.bidang_urusan_pemerintahan_id == '' || this.form.id_renstra == '' || this.form.bidang_urusan_pemerintahan_id == '') {
                    this.check_data_add = false;
                }else{
                        
                        this.check_data_add = true;
                        this.getKegiatan();
                }
            } ,
            format_uang : function(angka, prefix){
                    var rupiah = '';		
                    var angkarev = angka.toString().split('').reverse().join('');
                    for(var i = 0; i < angkarev.length; i++) if(i%3 == 0) rupiah += angkarev.substr(i,3)+'.';
                    return ''+rupiah.split('',rupiah.length-1).reverse().join('');
                },
        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
